export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/redux/constants/add_user.constants.js